import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'

@Component({
  selector: 'app-episode-link-column-renderer',
  template: `
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-default btn-xs dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Actions <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li (click)="clickReprocess()"><a href="javascript:void(0)">Reprocess</a></li>
        <li (click)="clickDeny()"><a href="javascript:void(0)">Deny</a></li>
      </ul>
    </div>
  `,
  standalone: false
})
export class ClaimActionsRendererComponent implements AgRendererComponent {
  public params: any

  agInit(params: any): void {
    this.params = params
  }

  refresh(params: any): boolean {
    return false
  }

  clickReprocess(): void {
    this.params.context.reprocessHandler(this.params.data)
  }

  clickDeny(): void {
    this.params.context.denyHandler(this.params.data)
  }
}
